const SOCIAL_LOGIN_PREFIXES = ['google-oauth2', 'apple'];

export function isSocialAuth0Id(userAuth0Id) {
  if (!userAuth0Id) {
    return false;
  }

  return SOCIAL_LOGIN_PREFIXES.includes(userAuth0Id.split('|')[0]);
}
